import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { ROUTER_CONFIG } from '@core/configs';
import { PermissionService } from '@core/services/common';

export const consolePermissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
  const router = inject(Router);
  const permissionService = inject(PermissionService);

  const permissionKey = route.data.permissionKey || '';
  const isAllowed = permissionService.isAllowed(permissionKey);
  if (!isAllowed) {
    router.navigate([ROUTER_CONFIG.forbidden]);
    return false;
  }
  return true;
};
